import { render, staticRenderFns } from "./vendors-summary-page.vue?vue&type=template&id=5834a778&scoped=true&"
import script from "./vendors-summary-page.vue?vue&type=script&lang=js&"
export * from "./vendors-summary-page.vue?vue&type=script&lang=js&"
import style0 from "./vendors-summary-page.vue?vue&type=style&index=0&id=5834a778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5834a778",
  null
  
)

export default component.exports